import React, { useEffect, useMemo, useState } from "react";
import { CardContainer } from "../../../components/Card/CardContainer";
import { useForm } from "antd/lib/form/Form";
import {
  Alert,
  Avatar,
  Button,
  Col,
  ConfigProvider,
  Divider,
  Modal,
  Row,
  Spin,
  Table,
  Tabs,
} from "antd";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import StepAntd from "../../../components/StepAntd/StepAntd";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Buttons from "../../../components/Button/Button";
import { StepOne } from "./Steps/Step1";
import dayjs from "dayjs";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  checkDupCampaign,
  createCampaign,
  getCampaignById,
  updateCampaign,
  updateCampaignFile,
} from "../../../datasource/CampaignDatasource";
import color from "../../../resource/color";
import Text from "../../../components/Text/Text";
import { StepTwoDup } from "./Steps/Step2Dup";
import { useMessageContext } from "../../../context/MessageProvider";
import image from "../../../resource/image";
import { WarningFilled } from "@ant-design/icons";
import { FlexCol } from "../../../components/Container/Container";
import styled from "styled-components";

export const CreateCampaignPoint: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname } = userProfile;
  const { messageApi } = useMessageContext();

  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[3];
  const isEditing = !!id;

  const [form1] = useForm();
  const [form2] = useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const { copyId } = useMemo(() => {
    return { copyId: searchParams.get("copy_id") };
  }, [searchParams]);

  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [modalConfirm, setModalConfirm] = useState<{ open: boolean; action: string; payload: any }>(
    {
      open: false,
      action: "",
      payload: null,
    },
  );
  const [modalCheckDup, setModalCheckDup] = useState<{
    open: boolean;
    payload: any;
    campaigns: any;
  }>({
    open: false,
    payload: null,
    campaigns: [],
  });
  const [modalDetailCheckDup, setModalDetailCheckDup] = useState(false);

  useEffect(() => {
    if ((isEditing || copyId) && !loading) {
      fetchCampaign();
    } else {
      form2.setFieldsValue({ campaignPrograms: [] });
    }
  }, [id, copyId]);

  const fetchCampaign = async () => {
    setLoading(true);
    const id = isEditing || !copyId ? pathSplit[3] : copyId;
    await getCampaignById(id)
      .then((res) => {
        form1.setFieldsValue({
          ...res,
          campaignCode: copyId ? res.campaignCode + "_copy" : res.campaignCode,
          campaignName: copyId ? res.campaignName + " (copy)" : res.campaignName,
          startDate: copyId ? undefined : dayjs(res.startDate),
          endDate: copyId ? undefined : dayjs(res.endDate),
          startTime: copyId ? dayjs("00:00", "HH:mm") : dayjs(res.startDate),
          endTime: copyId ? dayjs("23:59", "HH:mm") : dayjs(res.endDate),
          pointExpireDate: copyId ? undefined : dayjs(res.pointExpireDate),
          horizontalImage: res.imageFilename,
          horizontalImageUrl: res.imageFilename,
          documentUrl: res.documentFilename,
          memoFile: res.documentFilename,
          imagePath: res.imagePath,
          documentPath: res.documentPath,
        });
        const mapForm2 =
          res.campaignPrograms?.map((pg) => ({
            ...pg,
            campaignProgramDealers: pg.campaignProgramDealers?.map((s) => ({
              ...s,
              customerCompanyId: s.dealerId,
              customerNo: s.dealerCode,
              customerName: s.dealerName,
              zone: s.dealerZone,
              isChecked: false,
            })),
            searchDealer: pg.campaignProgramDealers?.map((s) => ({
              customerCompanyId: s.dealerId,
              customerNo: s.dealerCode,
              customerName: s.dealerName,
              zone: s.dealerZone,
              isChecked: false,
            })),
            campaignProgramProducts: pg.campaignProgramProducts?.map((p) => ({
              ...p,
              [`programPoints-${p.productId}`]: p.programPoints,
              isChecked: false,
            })),
            searchProduct: pg.campaignProgramProducts?.map((p) => ({
              ...p,
              [`programPoints-${p.productId}`]: p.programPoints,
              isChecked: false,
            })),
          })) || [];
        form2.setFieldsValue({ campaignPrograms: mapForm2 });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderStep = () => {
    switch (current) {
      case 0: {
        return <StepOne form={form1} form2={form2} />;
      }
      case 1: {
        return <StepTwoDup form1={form1} form2={form2} />;
      }
    }
  };

  const onNext = async () => {
    if (current === 0) {
      form1
        .validateFields()
        .then((values) => {
          const dataForm1 = form1.getFieldsValue(true);
          setCurrent(1);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const campaignPrograms = form2.getFieldValue("campaignPrograms") || [];
      const errors = campaignPrograms.flatMap((program: any, programIndex: number) =>
        (program.campaignProgramProducts || []).flatMap((product: any, productIndex: number) => {
          const fieldName = `programPoints-${product.productId}`;
          const value = product[fieldName];
          if (value === undefined || value === null || String(value).trim() === "") {
            return [
              {
                name: [
                  "campaignPrograms",
                  programIndex,
                  "campaignProgramProducts",
                  productIndex,
                  fieldName,
                ],
                errors: ["กรุณาระบุแต้มสินค้า"],
              },
            ];
          }
          return [];
        }),
      );
      if (errors.length > 0) {
        await form2
          .validateFields()
          .then((value: any) => {
            messageApi.error({
              type: "error",
              content: "กรุณากรอกข้อมูลให้ครบถ้วน",
            });
          })
          .catch((error) => {
            console.log("Validation failed for form2");
          });
        return;
      }
      try {
        await Promise.all([form1.validateFields(), form2.validateFields()]);
        const dataForm1 = form1.getFieldsValue(true);
        const dataForm2 = form2.getFieldsValue(true);

        const payload = {
          ...(isEditing && { campaignId: dataForm1.campaignId }),
          campaignCode: dataForm1.campaignCode,
          campaignName: dataForm1.campaignName,
          company: company,
          startDate: dayjs(
            dayjs(dataForm1.startDate).format("YYYY-MM-DD") +
              " " +
              dayjs(dataForm1.startTime).format("HH:mm"),
            "YYYY-MM-DD HH:mm",
          ).toISOString(),
          endDate: dayjs(
            dayjs(dataForm1.endDate).format("YYYY-MM-DD") +
              " " +
              dayjs(dataForm1.endTime).format("HH:mm"),
            "YYYY-MM-DD HH:mm",
          ).toISOString(),
          campaignCondition: dataForm1.campaignCondition,
          campaignProgramType: dataForm1.campaignProgramType,
          pointExpireDate: dayjs(
            dayjs(dataForm1.pointExpireDate).format("YYYY-MM-DD"),
          ).toISOString(),
          campaignDeadlines: dataForm1.campaignDeadlines.map((deadline) => ({
            deadlineMonth: deadline.deadlineMonth,
            subDealerSubmitDate: dayjs(
              dayjs(deadline.subDealerSubmitDate).format("YYYY-MM-DD"),
            ).toISOString(),
            dealerCheckDate: dayjs(
              dayjs(deadline.dealerCheckDate).format("YYYY-MM-DD"),
            ).toISOString(),
            companyApproveDate: dayjs(
              dayjs(deadline.companyApproveDate).format("YYYY-MM-DD"),
            ).toISOString(),
          })),
          createBy: firstname + " " + lastname,
          updateBy: firstname + " " + lastname,
          campaignPrograms: dataForm2.campaignPrograms.map((program) => ({
            campaignProgramName: program.campaignProgramName,
            campaignProgramCondition: program.campaignProgramCondition,
            updateBy: firstname + " " + lastname,
            campaignProgramDealers: program.campaignProgramDealers.map((dealer) => ({
              ...dealer,
              dealerId: dealer.customerCompanyId || undefined,
              dealerCode: dealer.customerNo || undefined,
              dealerName: dealer.customerName || undefined,
              dealerZone: dealer.zone || undefined,
              dealerType: dataForm1.campaignProgramType === "ONLY_DEALER" ? "DEALER" : "SUB_DEALER",
            })),
            campaignProgramProducts: program.campaignProgramProducts.map((product, index) => ({
              ...product,
              productId: product.productId || undefined,
              productName: product.productName || undefined,
              commonName: product.commonName || undefined,
              productGroup: product.productGroup || undefined,
              productStrategy: product.productStrategy || undefined,
              productLocation: product.productLocation || undefined,
              productCompany: company || undefined,
              productCodeNAV: product.productCodeNAV || undefined,
              productImage: product.productImage || undefined,
              saleUOM: product.saleUOM || undefined,
              saleUOMTH: product.saleUOMTH || undefined,
              programPoints: product[`programPoints-${product.productId || ""}`],
              packSize: product.packSize || undefined,
            })),
          })),
          imageFilename: dataForm1.imagePath || undefined,
          documentFilename: dataForm1.documentPath || undefined,
        };
        const { isOverlap, campaigns } = await checkDupCampaign({
          campaignId: payload.campaignId,
          company: company,
          startDate: payload.startDate,
          endDate: payload.endDate,
          productIds: payload.campaignPrograms.flatMap((program) =>
            program.campaignProgramProducts.map((product) => product.productId),
          ),
          subDealerIds: payload.campaignPrograms.flatMap((program) =>
            program.campaignProgramDealers.map((dealer) => dealer.dealerId),
          ),
        }).then((res) => {
          return res;
        });
        if (isOverlap) {
          setModalCheckDup({ open: true, payload, campaigns });
        } else {
          setModalConfirm({
            ...modalConfirm,
            open: true,
            action: isEditing ? "edit" : "create",
            payload,
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const onSubmit = async (payload: any) => {
    if (!isEditing) {
      await createCampaign(payload).then((res) => {
        const dataForm1 = form1.getFieldsValue(true);
        if (res.success) {
          setModalConfirm({ open: false, action: "", payload: null });
          createFile(res.responseData.campaignId, dataForm1);
        }
      });
    } else {
      await updateCampaign(payload).then((res) => {
        const dataForm1 = form1.getFieldsValue(true);
        if (res.success) {
          setModalConfirm({ open: false, action: "", payload: null });
          createFile(res.responseData.campaignId, dataForm1);
        }
      });
    }
  };

  const createFile = async (campaingId: string, dataForm1: any) => {
    const formData = new FormData();
    formData.append("campaignId", campaingId);
    formData.append("imageAction", dataForm1.imageAction);
    formData.append("documentAction", dataForm1.documentAction);
    formData.append("updateBy", `${firstname} ${lastname}`);
    if (dataForm1.imageAction !== "NO_ACTION") {
      formData.append("image", dataForm1.horizontalImage);
    } else {
      formData.append("image", dataForm1.imagePath);
    }
    if (dataForm1.documentAction !== "NO_ACTION") {
      formData.append("document", dataForm1?.memoFile?.file?.originFileObj);
    } else {
      formData.append("document", dataForm1.documentPath);
    }

    await updateCampaignFile(formData).then((res) => {
      setIsCreating(false);
      navigate("/crm/campaignPoint");
      messageApi.success({
        type: "success",
        content: "บันทึกสำเร็จ",
      });
    });
  };

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={`รายการแคมเปญพอยท์`}
        showBack
        extra={
          <StepAntd
            current={current}
            items={[
              {
                title: "รายละเอียดแคมเปญ",
              },
              {
                title: "เพิ่มพอยท์โปรแกรม",
              },
            ]}
          />
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการแคมเปญพอยท์", path: "/crm/campaignPoint" },
              ...(isEditing
                ? [
                    {
                      text: "รายละเอียดแคมเปญ",
                      path: `/crm/campaignPoint/${id}`,
                    },
                  ]
                : []),
              {
                text: "สร้างแคมเปญพอยท์",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
    );
  };

  const footer = () => {
    return (
      <Row justify='space-between' gutter={12}>
        <Col xl={3} sm={6}>
          {current > 0 && (
            <Buttons
              typeButton='primary-light'
              title='ย้อนกลับ'
              onClick={() => {
                setCurrent(current - 1);
                const dataForm2 = form2.getFieldsValue(true);
                form2.setFieldsValue({
                  campaignPrograms: dataForm2.campaignPrograms?.map((program: any) => ({
                    ...program,
                    isChecked: false,
                    campaignProgramDealers: program.campaignProgramDealers?.map((dealer: any) => ({
                      ...dealer,
                      isChecked: false,
                    })),
                    searchDealer: program.campaignProgramDealers?.map((dealer: any) => ({
                      ...dealer,
                      isChecked: false,
                    })),
                    campaignProgramProducts: program.campaignProgramProducts?.map(
                      (product: any) => ({
                        ...product,
                        isChecked: false,
                      }),
                    ),
                    searchProduct: program.campaignProgramProducts?.map((product: any) => ({
                      ...product,
                      isChecked: false,
                    })),
                  })),
                });
              }}
            />
          )}
        </Col>
        <Col xl={15} sm={6}></Col>
        <Col xl={3} sm={6}>
          <Buttons
            typeButton='primary'
            title={current === 1 ? "บันทึก" : "ถัดไป"}
            onClick={onNext}
            loading={loading}
          />
        </Col>
      </Row>
    );
  };

  return (
    <>
      <CardContainer>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            {" "}
            <PageTitle />
            <Divider />
            {renderStep()}
            <br />
            {footer()}
          </>
        )}
      </CardContainer>
      {modalConfirm.open && (
        <Modal
          open={modalConfirm.open}
          onCancel={() => setModalConfirm({ ...modalConfirm, open: false })}
          centered
          okText='ตกลง'
          cancelText='ยกเลิก'
          onOk={() => {
            setIsCreating(true);
            onSubmit(modalConfirm.payload);
          }}
          cancelButtonProps={{ style: { borderColor: color.primary, color: color.primary } }}
          confirmLoading={isCreating}
        >
          <Text level={2} fontWeight={700}>
            ยืนยันบันทึกการ{modalConfirm.action === "create" ? "สร้าง" : "แก้ไข"}แคมเปญพอยท์
          </Text>
          <br />
          {modalConfirm.action === "edit" && (
            <>
              <Text color='Text3'>
                เมื่อบันทึกการแก้ไขแล้ว{" "}
                <Text color='warning' fontWeight={400}>
                  ต้องให้ผู้มีสิทธิ์อนุมัติดำเนินการอนุมัติ
                </Text>
              </Text>
              <br />
            </>
          )}
          <Text color='Text3'>โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน</Text>
          <Divider size='small' />
        </Modal>
      )}
      {modalCheckDup.open && (
        <Modal
          keyboard={false}
          open={modalCheckDup.open}
          onOk={() => setModalCheckDup({ ...modalCheckDup, open: false })}
          onCancel={() => !isCreating && setModalCheckDup({ ...modalCheckDup, open: false })}
          centered
          footer={null}
          width={700}
          maskClosable={false}
        >
          <Row justify='center'>
            <img src={image.errorState} style={{ width: 250, height: 150 }} />
          </Row>
          <div style={{ textAlign: "center" }}>
            <Text level={3} fontWeight={600}>
              พบแคมเปญทับซ้อน
              <br /> กับแคมเปญอื่นที่เปิดใช้งานในช่วงเวลาเดียวกัน
            </Text>
          </div>
          <br />
          <div style={{ textAlign: "center" }}>
            <Text color='Text3'>
              แคมเปญนี้มีช่วงเวลา สินค้า และร้านค้าทับซ้อนกับแคมเปญอื่นที่เปิดใช้งาน
              <br /> ร้านค้าจึงอาจได้รับแต้มเบิ้ลซ้ำ
            </Text>
            <br />
            <br />
            <Text color='Text3'>
              คุณสามารถยืนยันบันทึกรายการนี้ต่อได้ทันที หากไม่ต้องการให้แคมเปญทับซ้อน
              <br />
              กรุณาตรวจสอบและกลับไปแก้ไขช่วงวันหรือเอาสินค้าที่ทับซ้อนออก
            </Text>
          </div>
          <br />
          <Row justify={"space-between"} gutter={8}>
            <Col span={12}>
              <Buttons
                typeButton='primary-light'
                onClick={() => {
                  setModalDetailCheckDup(true);
                  setModalCheckDup({ ...modalCheckDup, open: false });
                }}
                disabled={isCreating}
                title='ตรวจสอบแคมเปญ'
              />
            </Col>
            <Col span={12}>
              <Button
                loading={isCreating}
                onClick={() => {
                  setIsCreating(true);
                  onSubmit(modalCheckDup.payload).finally(() => setIsCreating(false));
                }}
                type='primary'
                style={{ height: "40px", width: "100%" }}
              >
                <Text color='white'>ยืนยันบันทึก และรออนุมัติ</Text>
              </Button>
            </Col>
          </Row>
        </Modal>
      )}
      {modalDetailCheckDup && (
        <ModalDetailCheckDup
          company={company}
          modalDetailCheckDup={modalDetailCheckDup}
          setModalDetailCheckDup={setModalDetailCheckDup}
          onCancel={() => {
            setModalCheckDup({ ...modalCheckDup, open: true });
            setModalDetailCheckDup(false);
          }}
          masterData={modalCheckDup.payload}
          dataDup={modalCheckDup.campaigns}
        />
      )}
    </>
  );
};

export const StyleModal = styled(Modal)`
  .ant-modal-content {
    padding: 0 !important;
    overflow: hidden;
    border-radius: 8px;
  }

  .ant-modal-body {
    padding: 0 !important;
  }

  .ant-modal-header {
    padding: 0 !important;
    margin-bottom: 0 !important;
  }

  .ant-modal-footer {
    padding: 0 !important;
  }
`;

const ModalDetailCheckDup = ({
  company,
  modalDetailCheckDup,
  setModalDetailCheckDup,
  masterData,
  onCancel,
  dataDup,
}: any) => {
  return (
    <StyleModal
      maskClosable={false}
      open={modalDetailCheckDup}
      onOk={() => setModalDetailCheckDup(false)}
      onCancel={onCancel}
      centered
      footer={null}
      width={1200}
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <div style={{ paddingRight: "16px", paddingLeft: "16px", paddingTop: "16px" }}>
        <Text level={3} fontWeight={600}>
          พบช่วงเวลาทับซ้อนกับแคมเปญอื่น
        </Text>
        <br />
        <Text color='Text3'>
          พบแคมเปญที่มีช่วงเวลาทับซ้อนกัน ร้านค้าที่อยู่ในทั้งสองแคมเปญ
          จึงอาจได้รับแต้มจากแคมเปญพร้อมกัน
        </Text>
      </div>
      <br />
      <div>
        <Alert
          message={
            <>
              <Text fontWeight={700} color='Text3'>
                แคมเปญที่กำลังจัดการ :{" "}
              </Text>
              &nbsp;
              <Text color='BK' fontWeight={700}>
                {masterData?.campaignName}
              </Text>
              &nbsp;
              <Text fontWeight={700} color='Text3'>
                ช่วงเวลา :{" "}
              </Text>
              &nbsp;
              <Text color='BK' fontWeight={700}>
                {dayjs(masterData?.startDate).format("DD/MM/BBBB")} -{" "}
                {dayjs(masterData?.endDate).format("DD/MM/BBBB")}
              </Text>
            </>
          }
          style={{ backgroundColor: "#F3F6F9", borderColor: "#F3F6F9", borderRadius: "0px" }}
          showIcon={false}
        />
      </div>
      <div style={{ padding: "16px" }}>
        <Alert
          message={
            <>
              <WarningFilled style={{ color: "white", fontSize: "16px" }} />
              &nbsp;
              <Text fontWeight={700} color='white'>
                แคมเปญที่ทับซ้อน
              </Text>
            </>
          }
          style={{ backgroundColor: "#FF9138", borderColor: "#FF9138" }}
          showIcon={false}
        />
        <div style={{ paddingTop: "8px", maxHeight: "min(400px, 60vh)", overflow: "auto" }}>
          {dataDup?.map((dup: any, index: number) => (
            <div key={index}>
              <Alert
                message={
                  <>
                    <Text fontWeight={700} color='Text3' level={6}>
                      {index + 1}. ชื่อแคมเปญ: :{" "}
                    </Text>
                    &nbsp;
                    <Text color='BK' fontWeight={700} level={6}>
                      {dup?.campaignName}
                    </Text>
                    &nbsp;
                    <Text fontWeight={700} color='Text3' level={6}>
                      ช่วงเวลา :{" "}
                    </Text>
                    &nbsp;
                    <Text color='BK' fontWeight={700} style={{ color: "#D97706" }} level={6}>
                      {dayjs(dup?.startDate).format("DD/MM/BBBB")} -{" "}
                      {dayjs(dup?.endDate).format("DD/MM/BBBB")}
                    </Text>
                  </>
                }
                style={{ backgroundColor: "#FFF4E6", borderColor: "#FFF4E6" }}
                showIcon={false}
              />
              <br />
              <Tabs
                style={{ fontFamily: "IBM Plex Sans Thai" }}
                items={[
                  ...(dup?.products?.length > 0
                    ? [
                        {
                          key: "1",
                          label: (
                            <div
                              style={{ fontWeight: 700 }}
                            >{`สินค้าที่ทับซ้อน (${dup?.products?.length})`}</div>
                          ),
                          children: (
                            <ConfigProvider
                              theme={{
                                components: {
                                  Table: {
                                    headerBg: "#F3F6F9",
                                    fontFamily: "IBM Plex Sans Thai",
                                    fontSize: 15,
                                  },
                                },
                              }}
                            >
                              <Table
                                pagination={false}
                                columns={[
                                  {
                                    title: "ชื่อสินค้า",
                                    dataIndex: "productName",
                                    key: "productName",
                                    render: (value, row: any) => {
                                      return (
                                        <Row
                                          gutter={8}
                                          style={{ padding: "12px 0px" }}
                                          align='middle'
                                        >
                                          <Col>
                                            <Avatar
                                              src={
                                                row.productImage
                                                  ? row.productImage
                                                  : image.product_no_image
                                              }
                                              size={70}
                                              shape='square'
                                              onError={() => false}
                                            />
                                          </Col>
                                          <Col>
                                            <Text>
                                              {row.productName}
                                              <br />
                                            </Text>
                                            {row.commonName && row.commonName.length > 0 && (
                                              <>
                                                <Text level={6}>
                                                  {row.commonName.length > 35
                                                    ? row.commonName.slice(0, 35) + "..."
                                                    : row.commonName}
                                                </Text>
                                                <br />
                                              </>
                                            )}
                                            <Text level={6} color='Text3'>
                                              Product Group : {row.productGroup || "-"}
                                            </Text>
                                            {company === "ICPL" && (
                                              <>
                                                <br />
                                                <Text level={6} color='Text3'>
                                                  Stragery Group : {row.productStrategy || "-"}
                                                </Text>
                                              </>
                                            )}
                                          </Col>
                                        </Row>
                                      );
                                    },
                                  },
                                  {
                                    dataIndex: "packSize",
                                    key: "packSize",
                                    render: (value, row: any) => {
                                      return (
                                        <FlexCol>
                                          <Text>{value}</Text>
                                          <Text color='Text3'>{row.productCodeNAV}</Text>
                                        </FlexCol>
                                      );
                                    },
                                  },
                                  {
                                    title: "แต้มที่ได้รับ",
                                    dataIndex: "programPoints",
                                    key: "programPoints",
                                    render: (value, row: any) => (
                                      <Text>
                                        {value} แต้ม / {row.saleUOMTH}
                                      </Text>
                                    ),
                                  },
                                ]}
                                dataSource={dup?.products}
                                size='small'
                              />
                            </ConfigProvider>
                          ),
                        },
                      ]
                    : []),
                  ...(dup?.subDealers?.length > 0
                    ? [
                        {
                          key: "2",
                          label: (
                            <div
                              style={{ fontWeight: 700 }}
                            >{`ร้านค้าที่ทับซ้อน (${dup?.subDealers?.length})`}</div>
                          ),
                          children: (
                            <ConfigProvider
                              theme={{
                                components: {
                                  Table: {
                                    headerBg: "#F3F6F9",
                                    fontFamily: "IBM Plex Sans Thai",
                                    fontSize: 15,
                                  },
                                },
                              }}
                            >
                              <Table
                                pagination={false}
                                columns={[
                                  {
                                    title: "รหัสร้านค้า",
                                    dataIndex: "subDealerCode",
                                    key: "subDealerCode",
                                  },
                                  {
                                    title: "ชื่อร้านค้า",
                                    dataIndex: "subDealerName",
                                    key: "subDealerName",
                                  },
                                  {
                                    title: "เขต",
                                    dataIndex: "subDealerZone",
                                    key: "subDealerZone",
                                  },
                                ]}
                                dataSource={dup?.subDealers}
                                size='small'
                              />
                            </ConfigProvider>
                          ),
                        },
                      ]
                    : []),
                ]}
              />
              <br />
            </div>
          ))}
        </div>
      </div>
    </StyleModal>
  );
};
